<template>
  <el-dialog
    title="Đọc thẻ"
    :visible.sync="dialogCardReaderVisible"
    :close-on-click-modal="false"
    width="500px"
    append-to-body
    @close="
      () => {
        cardNum = null
      }
    "
  >
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-12">
            <div class="das-form-input">
              <div class="label">Vui lòng đưa thẻ vào đầu đọc</div>
              <div
                class="child-w-80 align-center"
                style="margin-top: 10px; display: flex; justify-content: center"
              >
                <img height="300px" src="@/assets/images/nfc_reader.png" />
              </div>
              <input
                ref="hidden_id_card_inp"
                v-model="cardNum"
                style="opacity: 0; height: 0px"
                type="text"
                @change="handleChangeCardNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small"
          @click="dialogCardReaderVisible = false"
        >
          {{ $t('button.cancel') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      cardNum: null
    }
  },
  computed: {
    dialogCardReaderVisible: {
      get() {
        if (this.value) {
          this.$nextTick(() => {
            // Focus on the input using its ref
            this.$refs.hidden_id_card_inp.focus()
          })
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    handleChangeCardNumber() {
      this.$emit('change', this.cardNum)
      this.dialogCardReaderVisible = false
    }
  }
}
</script>
